(function () {
    "use strict";

    // @ngInject
    function PvlInquiryVendorsControllerCtor($scope, $injector, $modalInstance, UsersManager, UserService) {
        this.constructor.$super.call(this, $scope, $injector);
        this._objectType = 'PvlInquiryVendorsController';

        this.modalInstance = $modalInstance;
        this.UserService = UserService;
        this.UsersManager = UsersManager;

        this.user = this.UsersManager.getCurrUser();
    }

    Controllers.PvlInquiryVendorsController = Class(Controllers.BaseController, {
        constructor: PvlInquiryVendorsControllerCtor,


        modalDismissed: function modalDismissed() {
            this.modalInstance.dismiss();
        },

        clickFreeWalkthrough: function clickFreeWalkthrough() {
            this.UserService.openAECalendlyLink(this.user, 'pvl');
            this.modalInstance.dismiss();
        }
    });
}());
